module.exports = __webpack_public_path__ + "img/6.ab75da3.png";